
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppButton } from '@/components';
import { useSurpriseCategoryEdit } from '@/modules/surprise/category/model/edit';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useSurpriseCategoryEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
